export default function Footer() {
    return (
        <footer>
            <span>
                <a href="/">Copião</a> ★ Desenvolvido com amor por{" "}
                <a href="https://www.linkedin.com/in/jasmgermano/">Jasmine</a>
            </span>
        </footer>
    );
}